import { render, staticRenderFns } from "./3DButton.vue?vue&type=template&id=4d1c1bb5&scoped=true&"
import script from "./3DButton.vue?vue&type=script&lang=js&"
export * from "./3DButton.vue?vue&type=script&lang=js&"
import style0 from "./3DButton.vue?vue&type=style&index=0&id=4d1c1bb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c1bb5",
  null
  
)

export default component.exports